import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ArtworkDescription as ArtworkDescriptionType } from '@definitions/artworks.types';

import { PointTitle } from '../pdp.styles';

import { Container, Title, LongDescription, Content } from './artworkDescription.styles';

export interface ArtworkDetailsProps {
  description: ArtworkDescriptionType;
  title: string;
}

export const ArtworkDescription = ({ description, title }: ArtworkDetailsProps) => (
  <Container>
    <PointTitle>
      <FormattedMessage id="artworkDescription.pointTitle" defaultMessage="① Artwork:" />
    </PointTitle>
    <Content>
      <Title>{title}</Title>
      <LongDescription dangerouslySetInnerHTML={{ __html: description.longDescription }} />
    </Content>
  </Container>
);
